var map = {
	"./android.svg": 64354,
	"./duplicate.svg": 184,
	"./ios.svg": 41924,
	"./linux.svg": 59893,
	"./logout-illustration.svg": 27110,
	"./logout.svg": 32019,
	"./mac.svg": 69926,
	"./refresh.svg": 50054,
	"./ubuntu.svg": 40364,
	"./windows.svg": 61516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94203;